module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=GS - South Georgia and the South Sandwich Islands.9fb785a9.svg";